<template>
    <t-space direction="vertical" style="width: 100%;" size="small">
        <t-row style="width: 100%;" :gutter="16">
            <t-col></t-col>
            <t-col>
                <t-card brodered style="width: 85vw;" title="员工管理" :hoverShadow="true">
                    <t-space direction="vertical" style="width: 100%;">
                        <div>
                            <t-button @click="AddStaff">新增员工信息</t-button>
                        </div>
                        <t-empty v-if="listRef.length === 0" style="margin-top: 5vh; margin-bottom: 3vh;"/>
                        <t-list :split="true" style="height: 60vh" v-if="listRef.length !== 0">
                            <t-list-item v-for="(item, index) in listRef" :key="index" >
                                <t-list-item-meta   :image="avatarUrl" :title="item.title" :description="item.content" />
                                    <template #action>
                                        <t-tooltip content="编辑信息">
                                            <t-button variant="text" shape="square" @click="EditStaff(index)">
                                                <edit-icon />
                                            </t-button>
                                        </t-tooltip>
                                        <t-tooltip content="查看详情" >
                                            <t-button variant="text" shape="square" @click="ShowDetails(index)">
                                                <user-list-icon/>
                                            </t-button>
                                        </t-tooltip>
                                        <t-tooltip content="清空绩效">
                                            <t-button variant="text" shape="square" @click="ClearKPI(index)">
                                                <ChartAnalyticsIcon />
                                            </t-button>
                                        </t-tooltip>
                                        <t-tooltip content="删除">
                                            <t-button variant="text" shape="square" @click="DeleteStaff(index)">
                                                <user-clear-icon />
                                            </t-button>
                                        </t-tooltip>
                                    </template>
                            </t-list-item>
                        </t-list>
                    </t-space>
                </t-card>
            </t-col>
        </t-row>
        <!--员工细节查看弹窗-->
        <t-dialog   v-model:visible="staffDetailsVisible"  
                    header="员工信息" 
                    width="40vw"
                    @confirm="() => {staffDetailsVisible = false}"
                    :cancelBtn="null">
            <t-space>
                <t-descriptions  bordered >
                    <t-descriptions-item label="编号">{{staffDetailsInfo.id}}</t-descriptions-item>
                    <t-descriptions-item label="姓名">{{staffDetailsInfo.name}}</t-descriptions-item>
                    <t-descriptions-item label="简称">{{staffDetailsInfo.brief_name}}</t-descriptions-item>
                    <t-descriptions-item label="手机号码">{{staffDetailsInfo.phone_number}}</t-descriptions-item>
                    <t-descriptions-item label="登录密码">{{staffDetailsInfo.login_password}}</t-descriptions-item>
                    <t-descriptions-item label="拼音码">{{staffDetailsInfo.pinyin_code}}</t-descriptions-item>
                    <t-descriptions-item label="状态">{{staffDetailsInfo.status}}</t-descriptions-item>
                    <t-descriptions-item label="是否为管理员">{{staffDetailsInfo.is_manager==="1"?"是":"否"}}</t-descriptions-item>
                    <t-descriptions-item label="是否可登录">{{staffDetailsInfo.is_login_user==="1"?"是":"否"}}</t-descriptions-item>
                    <t-descriptions-item label="备注">{{staffDetailsInfo.remark}}</t-descriptions-item>
                    <t-descriptions-item label="员工绩效">
                        <t-tooltip placement="bottom" content="∑商品返点比例*（订单发送额-退货发生额）">
                            ￥{{staffDetailsInfo.kpi}}
                        </t-tooltip>
                    </t-descriptions-item>

                </t-descriptions>
            </t-space>
        </t-dialog>
        <!--新增员工窗口-->
        <t-dialog 
                v-model:visible="addStaffDialogVisible"
                :top="'50px'" 
                :confirmBtn="null"
                :cancelBtn="null"
                header="新增员工信息">
            <t-form :rules="rules"
                    :data="formData"
                    @submit="SubmitCreateStaffForm">
                <t-form-item label="编号" name="id"> 
                    <t-input v-model="formData.id" placeholder="请输入员工编号" />
                </t-form-item>
                <t-form-item label="姓名" name="name"> 
                    <t-input v-model="formData.name" placeholder="请输入员工姓名" />
                </t-form-item>
                <t-form-item label="简称" name="brief_name"> 
                    <t-input v-model="formData.brief_name" placeholder="请输入员工简称" />
                </t-form-item>
                <t-form-item label="手机号" name="phone_number"> 
                    <t-input v-model="formData.phone_number" placeholder="请输入员工手机号" />
                </t-form-item>
                <t-form-item label="是否可登录" name="is_login_user" > 
                    <t-radio-group default-value="1" @change="IsLoginUserRadioGroupChange">
                        <t-radio value="1">是</t-radio>
                        <t-radio value="0">否</t-radio>
                    </t-radio-group>
                </t-form-item>
                <t-form-item label="登录密码" name="login_password"> 
                    <t-input v-model="formData.login_password" placeholder="请输入员工密码" />
                </t-form-item>
                <t-form-item label="是否为管理员" name="is_manager"> 
                    <t-radio-group default-value="1"  @change="IsManagerRadioGroupChange">
                        <t-radio value="1">是</t-radio>
                        <t-radio value="0">否</t-radio>
                    </t-radio-group>
                </t-form-item>
                <t-form-item label="拼音码" name="pinyin_code"> 
                    <t-input v-model="formData.pinyin_code" placeholder="请输入员工拼音码" />
                </t-form-item>
                <t-form-item label="状态" name="status" >
                    <t-radio-group default-value="1" @change="StatusRadioGroupChange">
                        <t-radio value="1">正常</t-radio>
                        <t-radio value="0">停用</t-radio>
                    </t-radio-group>
                </t-form-item>
                <t-form-item label="备注" name="remark">
                    <t-textarea v-model="formData.remark" placeholder="请输入备注" :maxlength="50"/>
                </t-form-item>
                <t-form-item>
                    <t-button theme="primary" type="submit">提交</t-button>
                </t-form-item>
            </t-form>
        </t-dialog>
        <!--修改员工窗口-->
        <t-dialog   v-model:visible="staffModifyDialogVisible"  
                    header="员工信息" 
                    :top="'50px'"
                    :confirmBtn="null"
                    :cancelBtn="null">
            <t-space>
                <t-form :rules="rules" 
                        :data="staffDetailsInfo"
                        @submit="ModifiedStaffInfo"
                        >
                        <t-form-item label="编号" name="id">
                            <t-input v-model="staffDetailsInfo.id" placeholder="请输入员工编号" />
                        </t-form-item>
                        <t-form-item label="姓名" name="name">
                            <t-input v-model="staffDetailsInfo.name" placeholder="请输入员工姓名" />
                        </t-form-item>
                        <t-form-item label="简称" name="brief_name">
                            <t-input v-model="staffDetailsInfo.brief_name" placeholder="请输入员工简称" />
                        </t-form-item>
                        <t-form-item label="手机号码" name="phone_number">
                            <t-input v-model="staffDetailsInfo.phone_number" placeholder="请输入员工手机号" />
                        </t-form-item>
                        <t-form-item label="登录密码" name="login_password">
                            <t-input v-model="staffDetailsInfo.login_password" placeholder="请输入员工密码" />
                        </t-form-item>
                        <t-form-item label="拼音码" name="pinyin_code">
                            <t-input v-model="staffDetailsInfo.pinyin_code" placeholder="请输入拼音码" />
                        </t-form-item>
                        <t-form-item label="状态" name="status">
                            <t-radio-group :default-value="staffDetailsInfo.status==='正常'?'1':'0'" @change="(value)=>{staffDetailsInfo.status = value}">
                                <t-radio value="1">正常</t-radio>
                                <t-radio value="0">停用</t-radio>
                            </t-radio-group>
                        </t-form-item>
                        <t-form-item label="是否为管理员" name="is_manager">
                            <t-radio-group :default-value="staffDetailsInfo.is_manager" @change="(value)=>{staffDetailsInfo.is_manager = value}">
                                <t-radio value="1">是</t-radio>
                                <t-radio value="0">否</t-radio>
                            </t-radio-group>
                        </t-form-item>
                        <t-form-item label="是否可登录" name="is_login_user">
                            <t-radio-group :default-value="staffDetailsInfo.is_login_user"  @change="(value)=>{staffDetailsInfo.is_login_user = value}">
                                <t-radio value="1">是</t-radio>
                                <t-radio value="0">否</t-radio>
                            </t-radio-group>
                        </t-form-item>
                        <t-form-item label="备注" name="remark">
                            <t-textarea v-model="staffDetailsInfo.remark" placeholder="请输入备注" :maxlength="50"/>
                        </t-form-item>
                        <t-form-item>
                            <t-button theme="primary" type="submit">修改</t-button>
                        </t-form-item>
                </t-form>
            </t-space>
        </t-dialog>
    </t-space>
</template>

<script lang="jsx" setup>
import { EditIcon, UserListIcon,UserClearIcon,ChartAnalyticsIcon } from 'tdesign-icons-vue-next';
import { NotifyPlugin } from 'tdesign-vue-next';
import { onMounted, ref } from 'vue';
import request from '../../../request/request'

const staffModifyDialogVisible = ref(false)
const staffDetailsVisible = ref(false)
const addStaffDialogVisible = ref(false)
const listCurrentClickIndex = ref(-1)
const staffDetailsInfo = ref({})
const formData =ref({
    id: "",
    name: "",
    brief_name: "",
    phone_number: "",
    is_login_user: "1",
    login_password: "",
    is_manager: "1",
    pinyin_code: "",
    status: "1",
    remark: ""
})

const avatarUrl = 'https://tdesign.gtimg.com/site/avatar.jpg';
const listRef = ref([]);
const rules = {
    id: [
        { required: true, message: '编号必填', type: 'error', trigger: 'submit' },
        { whitespace: true, message: '编号不能为空' }
    ],
    name: [
        { required: true, message: '姓名必填', type: 'error', trigger: 'submit' },
        { whitespace: true, message: '姓名不能为空' }
    ],
    brief_name: [],
    phone_number: [
        { required: true, message: '手机号必填', type: 'error', trigger: 'submit' },
        { whitespace: true, message: '手机号不能为空' }
    ],
    is_login_user: [
        { required: true, message: '必须决定用户是否登录', type: 'error', trigger: 'submit' },
        { whitespace: true, message: '必须决定用户是否登录' }
    ],
    login_password: [

    ],
    is_manager: [
        { required: true, message: '必须决定用户是否为管理', type: 'error', trigger: 'submit' },
        { whitespace: true, message: '必须决定用户是否为管理' }
    ],
    pinyin_code: [],
    status: [],
    remark: []
}
onMounted(()=>{
    request.RequestStaffInfo(0,10,null,(res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                let value = {}
                value.title = data[i].staffName
                value.content = (data[i].remark === null || data[i].remark === undefined) ? "无详细描述" : data[i].remark
                value.id = data[i].staffId
                value.name = data[i].staffName
                value.brief_name = data[i].briefName
                value.login_password = data[i].loginPassword
                value.phone_number = data[i].staffPhoneNumber
                value.pinyin_code = data[i].pinyinCode
                value.remark = data[i].remark
                value.is_manager = data[i].isManager?"1":"0"
                value.is_login_user = data[i].isLoginUser?"1":"0"
                value.status = data[i].status
                value.kpi = data[i].kpi
                listRef.value.push(value)
            }
            console.log("request staff info",listRef.value)
        }else {
            NotifyPlugin.error({
                title: "获取员工信息失败",
                message: "获取员工信息失败",
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            theme: '数据获取失败',
            content: '获取员工信息失败' + err,
            duration: 3000
        })
    })
})
const ShowDetails = (index)=>{
    listCurrentClickIndex.value = index
    staffDetailsInfo.value = listRef.value[index]
    staffDetailsVisible.value = true
}

const DeleteStaff = (index) => {
    let id = listRef.value[index].id
    request.RequestDeleteStaffInfo(id,(res)=>{
        if(res.data.success) {
            listRef.value.splice(index,1)
            NotifyPlugin.success({
                placement: 'top-right',
                title: '删除成功',
                content: '删除员工信息成功',
                duration: 3000,
            })
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '删除失败',
                content: '删除员工信息失败',
                duration: 3000,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            theme: '数据获取失败',
            content: '删除员工信息失败' + err,
            duration: 3000
        })
    })
}
const AddStaff = ()=>{
    addStaffDialogVisible.value = true
}

const IsLoginUserRadioGroupChange = (value)=>{
    formData.value.is_login_user = value
}

const IsManagerRadioGroupChange = (value) => {
    formData.value.is_manager = value
}

const StatusRadioGroupChange = (value)=>{
    formData.value.status = value
} 

const SubmitCreateStaffForm = ({ validateResult, firstError })=>{
    if (validateResult === true) {
        request.RequestAddStaff(
            formData.value,
            (res)=>{
                if(res.data.success) {
                    NotifyPlugin.success({
                        placement: 'top-right',
                        title: '添加成功',
                        content: '员工添加成功',
                        duration: 3000,
                    })
                    let addStaffInfo = {}
                    addStaffInfo =  Object.assign(addStaffInfo,formData.value)
                    addStaffInfo.title = formData.value.name
                    addStaffInfo.content = formData.value.remark
                    addStaffInfo.status = addStaffInfo.status === '1' ? "正常" : "停用"
                    listRef.value.push(addStaffInfo)
                    addStaffDialogVisible.value = false
                }else {
                    NotifyPlugin.error({
                        placement: 'top-right',
                        title: '添加失败',
                        content: '员工添加失败，其联系管理人员',
                        duration: 3000,
                    })
                }
            },
            (err)=>{
                NotifyPlugin.error({
                    placement: 'top-right',
                    title: '添加失败',
                    content: '员工添加失败，其联系管理人员' + err,
                    duration: 3000,
                })
            }
        )
    } else {
        NotifyPlugin.warning({
            placement: 'top-right',
            title: firstError,
            duration: 3000
        });
    }
}

const ModifiedStaffInfo = ({ validateResult, firstError })=>{
    if (validateResult === true) {
        request.RequestModifiedStaffInfo(listRef.value[listCurrentClickIndex.value].id,staffDetailsInfo,
        (res)=>{
            if(res.data.success) {
                NotifyPlugin.success({
                    placement: 'top-right',
                    title: '修改成功',
                    content: '员工信息修改成功',
                    duration: 3000,
                })
                listRef.value[listCurrentClickIndex.value].id = staffDetailsInfo.value.id
                listRef.value[listCurrentClickIndex.value].name = staffDetailsInfo.value.name
                listRef.value[listCurrentClickIndex.value].briefName = staffDetailsInfo.value.brief_name
                listRef.value[listCurrentClickIndex.value].phone_number = staffDetailsInfo.value.phone_number
                listRef.value[listCurrentClickIndex.value].login_password = staffDetailsInfo.value.login_password
                listRef.value[listCurrentClickIndex.value].pinyin_code = staffDetailsInfo.value.pinyin_code
                listRef.value[listCurrentClickIndex.value].status = staffDetailsInfo.value.status === "1"?"正常":"停用"
                listRef.value[listCurrentClickIndex.value].remark = staffDetailsInfo.value.remark
                listRef.value[listCurrentClickIndex.value].is_login_user = staffDetailsInfo.value.is_login_user
                listRef.value[listCurrentClickIndex.value].is_manager = staffDetailsInfo.value.is_manager
                staffModifyDialogVisible.value = false
            }else {
                NotifyPlugin.info({
                    placement: 'top-right',
                    title: '修改失败',
                    content: "员工信息修改失败",
                    duration: 3000,
                })
            }
        },
        (err)=>{
            NotifyPlugin.info({
                placement: 'top-right',
                title: '修改失败' + err,
                content: err,
            })
        })
    }else {
        NotifyPlugin.warning({
            placement: 'top-right',
            title: firstError,
            duration: 3000
        });
    }
}
const EditStaff = (index) => {
    listCurrentClickIndex.value = index
    staffDetailsInfo.value = listRef.value[index]
    staffModifyDialogVisible.value = true
}

const clearParam =ref()
const ClearKPI = (index)=>{
    listRef.value[index].kpi = 0
    let param = {
        ...listRef.value[index]
    }
    
    clearParam.value = param
    request.RequestModifiedStaffInfo(param.id,clearParam,(res)=>{
        if(res.data && res.data.success) {
            NotifyPlugin.success({
                title: "清空绩效成功",
                content: '清空绩效成功',
                duration: 3000
            })
        }else {
            NotifyPlugin.err({
                placement: 'top-right',
                title: '清空绩效失败',
                content: '清空绩效失败',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.err({
            placement: 'top-right',
            title: "清空绩效失败。" + JSON.stringify(err),
            duration: 3000
        });
    })
}
</script>

<style scoped>

</style>